/* T&L Equipment theme — minimal vanilla JS, no dependencies */
(function () {
  'use strict';

  /* ---- Mobile nav drawer ---- */
  function bindDrawer() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-mobile-nav]');
    if (!toggle || !drawer) return;
    var open = function () { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; };
    var close = function () { drawer.classList.remove('open'); document.body.style.overflow = ''; };
    toggle.addEventListener('click', open);
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.hasAttribute('data-nav-close')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- Quantity steppers (product page) ---- */
  function bindQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-step') === 'down' ? -1 : 1;
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---- Product gallery thumbs ---- */
  function bindGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-full');
        if (mainImg && src) { mainImg.src = src; mainImg.srcset = ''; }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  }

  /* ---- Predictive search (header, drawer, hero, search page) ----
     Google-style live suggestions on every search form, via Shopify's
     /search/suggest.json (client asked 2026-07-16: "live populate as they
     search"). Matches on title, SKU, barcode, type, and vendor so part-number
     lookups hit. No dependencies; stale responses cancelled via AbortController. */
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function bindPredictive() {
    document.querySelectorAll('form[role="search"]').forEach(function (form) {
      var input = form.querySelector('input[type="search"]');
      if (!input) return;
      var box = document.createElement('div');
      box.className = 'suggest';
      box.hidden = true;
      form.style.position = 'relative';
      form.appendChild(box);
      input.setAttribute('autocomplete', 'off');
      var timer = null, ctrl = null, cache = {};

      function close() {
        box.hidden = true;
        box.innerHTML = '';
      }
      function render(q, data) {
        var products = (((data || {}).resources || {}).results || {}).products || [];
        if (!products.length) { close(); return; }
        var html = products.map(function (p) {
          var n = Number(p.price);
          var price = n > 0 ? '$' + n.toLocaleString(undefined, { minimumFractionDigits: 2 }) : 'Call for price';
          /* Thumbnail when the product has a photo; otherwise a small brand plate — the same
             honest-placeholder language the product cards use (client asked for images in
             search results 2026-07-17). */
          var img = (p.featured_image && p.featured_image.url) || p.image;
          var thumb;
          if (img) {
            var sep = img.indexOf('?') > -1 ? '&' : '?';
            thumb = '<img class="s-thumb" loading="lazy" alt="" src="' + escapeHtml(img + sep + 'width=80') + '">';
          } else {
            var ini = String(p.vendor || '').replace(/[^A-Za-z0-9]/g, '').slice(0, 2).toUpperCase() || '·';
            thumb = '<span class="s-ph" aria-hidden="true">' + escapeHtml(ini) + '</span>';
          }
          return '<a href="' + escapeHtml(p.url) + '">' + thumb + '<span class="s-title">' + escapeHtml(p.title) + '</span><span class="s-price">' + price + '</span></a>';
        }).join('');
        html += '<a class="s-all" href="' + form.getAttribute('action') + '?q=' + encodeURIComponent(q) + '&type=product">All results for “' + escapeHtml(q) + '” →</a>';
        box.innerHTML = html;
        box.hidden = false;
      }
      function fetchSuggest(q) {
        if (cache[q]) { render(q, cache[q]); return; }
        if (ctrl) ctrl.abort();
        ctrl = ('AbortController' in window) ? new AbortController() : null;
        var url = form.getAttribute('action') + '/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8' +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title,product_type,variants.sku,variants.barcode,vendor';
        fetch(url, ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data) return;
            cache[q] = data;
            if (input.value.trim() === q) render(q, data);
          })
          .catch(function () {});
      }
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { close(); return; }
        timer = setTimeout(function () { fetchSuggest(q); }, 180);
      });
      input.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        var opts = box.querySelectorAll('a');
        var idx = -1;
        opts.forEach(function (o, i) { if (o.classList.contains('active')) idx = i; });
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          idx = e.key === 'ArrowDown' ? Math.min(idx + 1, opts.length - 1) : Math.max(idx - 1, 0);
          opts.forEach(function (o, i) { o.classList.toggle('active', i === idx); });
          if (opts[idx]) opts[idx].scrollIntoView({ block: 'nearest' });
        } else if (e.key === 'Enter' && idx >= 0) {
          e.preventDefault();
          window.location.href = opts[idx].getAttribute('href');
        } else if (e.key === 'Escape') {
          close();
        }
      });
      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) close();
      });
    });
  }

  /* ---- Live cart-count refresh (after AJAX or on load) ----
     [data-cart-count] now renders as a plain number inside a circular .count badge (header
     "ONE DECK" pass, 2026-07-16 — previously plain " (N)" text next to a text-only "Cart" link
     in the old util bar). Keep the JS format in sync with the badge markup in
     sections/header.liquid. */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? cart.item_count : '';
        });
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindDrawer();
    bindQty();
    bindGallery();
    bindPredictive();
    refreshCartCount();
  });
})();
